import {Injectable} from "@angular/core";
import {AgencyConfigService} from "./AgencyConfigService";

@Injectable()
export class Locupa2Service {

  locupa2Window: Window;

  constructor(private agencyConfigService: AgencyConfigService) {
  }

  openLocupa2Window(url) {
    let l2Window = window.open(this.agencyConfigService.getAgencyConfigData().locupa2 + url, 'locupa2');
    l2Window.focus();
    this.setLocupa2Window(l2Window);
  }

  setLocupa2Window(window: Window) {
    this.locupa2Window = window
  }

  closeWindow() {
    if (this.locupa2Window) {
      this.locupa2Window.close();
    }
  }

  getLocupa2TokenUrl() {
    return this.agencyConfigService.getAgencyConfigData().locupa2 + '/token';
  }

  getLocupa2Url() {
    return this.agencyConfigService.getAgencyConfigData().locupa2;
  }
}



// WEBPACK FOOTER //
// ./src/services/Locupa2Service.ts